import ImageContentModal from './ImageContentModal.component';

export default ImageContentModal;